import { useEffect } from "react";
import type { MetaDataPropertyType } from "types/metaDataPropertyTypes";
import type { PropertyCriteria } from "types/qbank/propertyCriteria";
import { SearchOperator } from "types/qbank/searchOperator";
import { Input } from "components/ui";

export default function Decimal(props: {
  propertyType: MetaDataPropertyType;
  setCriteria: (propertyCriteria: PropertyCriteria) => void;
  setValue: (values: number) => void;
  value: number;
}) {
  useEffect(() => {
      props.setCriteria({
        id: props.propertyType.id,
        systemName: props.propertyType.systemname,
        operator: SearchOperator.EQUAL,
        value: props.value !== undefined ? props.value : undefined,
        label: props.propertyType.name,
      });
    // eslint-disable-next-line
  }, [props.value]);

  return (
    <div className="field" data-testid="number">
      <label className="label">{props.propertyType.name}</label>

      <div className="control">
        <Input
          fullwidth
          type="number"
          value={props.value ?? ""}
          step={0.01}
          onChange={(e) => props.setValue(parseFloat(e.target.value))}
        />
      </div>
    </div>
  );
}
